import { FocusEvent, useContext } from "react";
import { ScriptSecretContext } from "routes/lens-editor/scripts/ScriptSecretContext";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, TextField } from "@mui/material";

const ScriptSecretDialog = ({
  open,
  close,
  onSave,
  helperText,
}: {
  open: boolean;
  close: () => void;
  onSave: () => void;
  helperText: string;
}) => {
  const [, setScriptSecret] = useContext(ScriptSecretContext);

  const handleFocus = (event: FocusEvent<any>) => {
    event.preventDefault();
    const { target } = event;
    target.focus();
  };

  return (
    <Dialog open={open} onClose={close} fullWidth maxWidth="md">
      <DialogTitle>Paste Script Approval Key</DialogTitle>
      <DialogContent>
        <FormControl fullWidth>
          <TextField
            id="scriptApprovalKeyInput"
            name="Script Approval Secret"
            autoFocus
            onFocus={handleFocus}
            type="password"
            onChange={(evt) => setScriptSecret(evt.target.value)}
            helperText={helperText}
          />
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          onClick={() => {
            setScriptSecret("");
            close();
          }}>
          Cancel
        </Button>
        <Button variant="contained" onClick={onSave}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ScriptSecretDialog;
